import { AlertTriangle } from "lucide-react";

const BackupEligibilityAlert = ({ caseCount, toFa }) => {
  return (
    <div className="flex items-start gap-3 rounded-2xl border border-[#E4B7AC] bg-[#FBEDE9] p-[18px]">
      <AlertTriangle size={22} className="text-[#A6402F] shrink-0" />
      <div>
        <div className="mb-1 font-bold">این امکان برای این حساب فعال نیست</div>
        <div className="text-sm leading-[1.9] text-[#5B5748]">
          تعداد پرونده‌های ثبت‌شده ({toFa(caseCount)}) کمتر از حد لازم است.
          پشتیبان‌گیری فقط برای وکلایی فعال است که بیش از ۵ پرونده ثبت کرده
          باشند.
        </div>
      </div>
    </div>
  );
};

export default BackupEligibilityAlert;
